import { Link } from 'react-router-dom';
import LegalFooter from '../components/shared/LegalFooter';
import '../styles/global.css';

export default function EnrollCancelledPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div className="topbar">
        <div className="topbar-logo">
          <div className="topbar-logo-dot" />
          Affordable Telecom LLC
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 480 }}>
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div
              aria-hidden="true"
              style={{
                width: 88, height: 88, borderRadius: '50%', background: 'var(--light-bg)',
                border: '1px solid var(--border)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="var(--muted)" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </div>
            <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--navy)', marginBottom: 8 }}>
              Enrollment Cancelled
            </h1>
            <p style={{ color: 'var(--text-sub)', fontSize: 15, lineHeight: 1.6, maxWidth: 400, margin: '0 auto' }}>
              No problem — your enrollment wasn't completed. You can try again anytime, or contact us if you need help.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Link to="/login" className="btn btn-primary btn-full" style={{ textDecoration: 'none' }}>
              Return to Sign In
            </Link>
            <a
              href="mailto:support@affordable-telecom.com"
              className="btn btn-outline btn-full"
              style={{ textDecoration: 'none' }}
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>

      <LegalFooter />
    </div>
  );
}
